/* collins-web.js: the web design page's one new move (snippets/web-design-body.liquid), on top of collins-home.js.
     - The headline ends "on any platform". On load its last words rise through a mask, one platform after another,
       once, and settle back on "any platform" (about 4.8 s: nothing moves on its own for longer, WCAG 2.2.2).
     - The platform rows: pointing at a row (or focusing it) stops the headline on that platform and quiets the other
       rows to 0.4; clicking or tapping opens its detail line and keeps it open until it is clicked again. Pointing
       never opens a row, so no row moves under the pointer.
     - Films marked data-wd-film (the Brew Bloom drawing film) play only while on screen, with a pause that wins.
   Reduced motion: no cycle and no transitions; the rows still answer, the words swap instantly; films show their
   poster until "Play the film" is pressed.
   No script: the headline reads "on any platform" and every detail line is open (the collapse needs html.wd-js).
   Teardown on pagehide and on shopify:section:unload. */
(function () {
  'use strict';
  var d = document, de = d.documentElement, w = window;
  var reduce = w.matchMedia('(prefers-reduced-motion: reduce)');
  var S = null;

  function init() {
    var slot = d.querySelector('[data-wd-slot]'), list = d.querySelector('[data-wd-list]');
    if (S || !slot || !list) return;
    S = { off: [], t: [] };
    var on = function (t, type, fn, opt) { t.addEventListener(type, fn, opt); S.off.push(function () { t.removeEventListener(type, fn, opt); }); };
    var later = function (fn, ms) { var id = w.setTimeout(fn, ms); S.t.push(id); return id; };
    var rows = Array.prototype.slice.call(list.querySelectorAll('[data-wd-row]'));
    var head = function (r) { return r.querySelector('.wd-head'); };
    var word = function (r) { return r.getAttribute('data-wd-word'); };
    var rest = slot.textContent.trim();
    var current = rest, cleanup = 0, cycling = true;

    de.classList.add('wd-js');

    /* one word out (up, through the mask), the next one in (up from below); the slot's width follows */
    function show(text) {
      if (!S || text === current) return;
      current = text;
      Array.prototype.forEach.call(slot.querySelectorAll('.wd-word.is-going'), function (n) { n.remove(); });
      var old = slot.querySelector('.wd-word');
      var next = d.createElement('span');
      next.className = 'wd-word';
      next.textContent = text;
      if (reduce.matches) {
        if (old) old.remove();
        slot.style.width = '';
        slot.appendChild(next);
        return;
      }
      slot.style.width = slot.getBoundingClientRect().width + 'px';
      if (old) old.classList.add('is-going');
      next.classList.add('is-in');
      slot.appendChild(next);
      var to = next.getBoundingClientRect().width;
      w.requestAnimationFrame(function () {
        if (!S) return;
        slot.style.width = to + 'px';
        next.classList.remove('is-in');
        if (old) old.classList.add('is-out');
      });
      w.clearTimeout(cleanup);
      cleanup = later(function () {
        Array.prototype.forEach.call(slot.querySelectorAll('.wd-word.is-going'), function (n) { n.remove(); });
        slot.style.width = '';
      }, 760);
    }

    /* the load-in: each platform marked data-wd-cycle once, then back to "any platform" */
    var seq = rows.filter(function (r) { return r.hasAttribute('data-wd-cycle'); }).map(word).concat([rest]);
    var stop = function () { cycling = false; };
    if (!reduce.matches) {
      var i = 0;
      var step = function () {
        if (!cycling || !S) return;
        show(seq[i]); i += 1;
        if (i < seq.length) later(step, 760); else cycling = false;
      };
      /* prompt 4 (21 Oct 2026): the headline's first line rises in depth first (collins-rise.css, about 1.6 s to settle
         after the opening sheet lifts), then the one pass of platforms; the pass itself is unchanged */
      var held = function () { return d.documentElement.classList.contains('cl-press-hold'); };
      if (held() && 'MutationObserver' in w) {
        var mo = new MutationObserver(function () { if (!held()) { mo.disconnect(); later(step, 1600); } });
        mo.observe(d.documentElement, { attributes: true, attributeFilter: ['class'] });
        S.off.push(function () { mo.disconnect(); });
      } else {
        later(step, 1600);
      }
    } else {
      cycling = false;
    }

    /* the rows */
    var pinned = null, pointed = null;
    function render() {
      var act = pointed || pinned;
      rows.forEach(function (r) {
        var open = r === pinned;
        r.classList.toggle('is-open', open);
        r.classList.toggle('is-act', r === act);
        var b = head(r); if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      list.classList.toggle('has-act', !!act);
      show(act ? word(act) : rest);
    }
    rows.forEach(function (r) {
      var b = head(r);
      if (!b) return;
      on(b, 'click', function () {
        stop();
        if (pinned === r) { pinned = null; pointed = null; } else { pinned = r; }
        render();
      });
      on(r, 'pointerenter', function (e) { if (e.pointerType !== 'mouse') return; stop(); pointed = r; render(); });
      on(b, 'focus', function () { if (!b.matches(':focus-visible')) return; stop(); pointed = r; render(); });
    });
    on(list, 'pointerleave', function (e) { if (e.pointerType !== 'mouse') return; pointed = null; render(); });
    on(list, 'focusout', function (e) { if (!list.contains(e.relatedTarget)) { pointed = null; render(); } });

    /* the films marked data-wd-film: play only while a quarter of it is on screen; the viewer's pause wins; under
       reduced motion or Save-Data only the poster shows until "Play the film" is pressed */
    Array.prototype.forEach.call(d.querySelectorAll('[data-wd-film]'), function (fig) {
      var v = fig.querySelector('video'), b = fig.querySelector('[data-wd-film-pause]');
      if (!v || !b) return;
      var userPaused = false;
      var quiet = reduce.matches || (navigator.connection && navigator.connection.saveData);
      var attach = function () {
        Array.prototype.forEach.call(v.querySelectorAll('source[data-src]'), function (s) { s.src = s.getAttribute('data-src'); s.removeAttribute('data-src'); });
        if (v.preload !== 'auto') { v.preload = 'auto'; v.load(); }
      };
      var play = function () { attach(); var p = v.play(); if (p && p.catch) p.catch(function () {}); };
      var label = function () { b.textContent = v.paused ? 'Play the film' : 'Pause the film'; };
      on(v, 'playing', function () { v.classList.add('is-on'); label(); });
      on(v, 'pause', label);
      on(b, 'click', function () { if (v.paused) { userPaused = false; play(); } else { userPaused = true; v.pause(); } label(); });
      b.hidden = false;
      b.textContent = 'Pause the film'; b.style.minWidth = (b.offsetWidth / parseFloat(w.getComputedStyle(b).fontSize)).toFixed(3) + 'em';   /* prompt 4: no width change between the labels */
      label();
      if ('IntersectionObserver' in w) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (!e.isIntersecting) { if (!v.paused) v.pause(); }
            else if (!userPaused && !quiet) play();
          });
        }, { threshold: 0.25 });
        io.observe(fig);
        S.off.push(function () { io.disconnect(); v.pause(); });
      }
    });

    S.reset = function () {
      rows.forEach(function (r) { r.classList.remove('is-open', 'is-act'); var b = head(r); if (b) b.setAttribute('aria-expanded', 'false'); });
      list.classList.remove('has-act');
      slot.style.width = '';
      slot.innerHTML = '';
      var n = d.createElement('span'); n.className = 'wd-word'; n.textContent = rest; slot.appendChild(n);
      de.classList.remove('wd-js');
    };
  }

  function destroy() {
    if (!S) return;
    var s = S; S = null;
    s.t.forEach(function (id) { w.clearTimeout(id); });
    for (var i = s.off.length - 1; i >= 0; i--) { try { s.off[i](); } catch (e) {} }
    if (s.reset) s.reset();
  }

  var ours = function (e) { return e.target && e.target.querySelector && e.target.querySelector('[data-wd-slot]'); };
  d.addEventListener('shopify:section:unload', function (e) { if (ours(e)) destroy(); });
  d.addEventListener('shopify:section:load', function (e) { if (ours(e)) { destroy(); init(); } });
  w.addEventListener('pagehide', destroy);
  w.addEventListener('pageshow', function (e) { if (e.persisted) init(); });
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
